import type { ReactNode } from 'react';

interface Props {
  kind?: 'ok' | 'err';
  children: ReactNode;
}

export function Toast({ kind = 'ok', children }: Props): JSX.Element {
  return (
    <div className={'toast' + (kind === 'err' ? ' err' : '')}>
      <span className="dot" />
      <span>{children}</span>
    </div>
  );
}
